import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux'
import { Action, combineReducers } from 'redux'
import { ThunkAction } from 'redux-thunk'
import agentProfileReducer from './App/AgentProfile/agentProfile.reducer'
import alertsReducer from './App/Alerts/alerts.reducer'
import { appReducer } from './App/app.reducer'
import { store } from './configureStore'
import ciscoConfigReducer from './App/ApplicationManagement/CiscoConfiguration/ciscoConfig.reducer'
import genesysConfigReducer from './App/ApplicationManagement/GenesysConfiguration/genesysConfig.reducer'
import stunTurnReducer from './App/ApplicationManagement/QmGlobalSettings/stunTurn.reducer'
import ringCentralConfigReducer from './App/ApplicationManagement/RingCentralConfiguration/ringCentralConfig.reducer'
import twilioConfigReducer from './App/ApplicationManagement/TwilioConfiguration/twilioConfig.reducer'
import uJetConfigReducer from './App/ApplicationManagement/UJetConfiguration/uJetConfig.reducer'
import passwordReducer from './App/Password/password.reducer'
import contactExportReducer from './App/Recordings/ContactExport/contactExport.reducer'
import createContactReducer from './App/Recordings/CreateContact/createContact.reducer'
import createTaskReducer from './App/Recordings/CreateTask/createTask.reducer'
import evaluationFormReducer from './App/Recordings/SingleEvaluationForm/evaluationForm.reducer'
import filterSetsReducer from './App/Recordings/FilterSets/filterSets.reducer'
import filterPanelFieldsReducer from './App/Recordings/FiltersPanel/filterPanelFields.reducer'
import markForCalibrationReducer from './App/Recordings/MarkForCalibration/markForCalibration.reducer'
import mediaReducer from './App/Recordings/MediaPlayer/mediaPlayer.reducer'
import recordingsReducer from './App/Recordings/recordings.reducer'
import singleContactExportReducer from './App/Recordings/SingleContactExportDialog/reducer'
import desktopPropertiesReducer from './Common/DesktopProperties/desktopProperties.reducer'
import { stytchWrapper } from './Common/StytchWrapper/reducer'
// import { efmApiSlice } from './App/ApplicationManagement/EvaluationFormManager/RTK/efm.api'
import efmTableSlice from './App/ApplicationManagement/EvaluationFormManager/RTK/efmTable.slice'
import efmGlobalSlice from './App/ApplicationManagement/EvaluationFormManager/RTK/efmGlobal.slice'
import efmFormSlice from './App/ApplicationManagement/EvaluationFormManager/RTK/efmForm.slice'
import { efmTemplateApiSlice } from './App/ApplicationManagement/EvaluationFormManager/RTK/efmTemplate.api'
import { rootApi } from './root.api'
import avayaAxpPublicConfigReducer from './App/ApplicationManagement/AvayaAxpPublicConfiguration/avayaAxpPublicConfig.reducer'

export const rootReducer = combineReducers({
  app: appReducer,
  createContact: createContactReducer,
  createTask: createTaskReducer,
  alerts: alertsReducer,
  password: passwordReducer,
  recordings: recordingsReducer,
  evaluation: evaluationFormReducer,
  media: mediaReducer,
  markForCalibration: markForCalibrationReducer,
  contactExport: contactExportReducer,
  filterSets: filterSetsReducer,
  filterPanelFields: filterPanelFieldsReducer,
  stytchWrapper,
  agentProfile: agentProfileReducer,
  singleContactExport: singleContactExportReducer,
  desktopProperties: desktopPropertiesReducer,
  stunTurn: stunTurnReducer,
  twilioConfig: twilioConfigReducer,
  uJetConfig: uJetConfigReducer,
  genesysConfig: genesysConfigReducer,
  ciscoConfig: ciscoConfigReducer,
  ringCentral: ringCentralConfigReducer,
  avayaAxpPublic: avayaAxpPublicConfigReducer,
  [rootApi.reducerPath]: rootApi.reducer,
  // [efmApiSlice.reducerPath]: efmApiSlice.reducer,
  [efmTemplateApiSlice.reducerPath]: efmTemplateApiSlice.reducer,
  efmTable: efmTableSlice,
  efmGlobal: efmGlobalSlice,
  efmForm: efmFormSlice,
})

export default rootReducer
export type RootState = ReturnType<typeof store.getState>
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action<string>>

// Dispatch & Select for RTK + Typescript
export type AppDispatch = typeof store.dispatch
export const useAppDispatch: () => AppDispatch = useDispatch
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector
